module.exports = __webpack_public_path__ + "static/media/viva.17012232.svg";